/**
 * Convert any backend error (FastAPI/Pydantic/Axios) into a human-readable string.
 * Pydantic v2 returns `detail: [{type, loc, msg, input, ctx, url}, ...]`.
 */
export function errorToString(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const loc = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
        return `${loc ? loc + ": " : ""}${d.msg || d.type || "invalid"}`;
      })
      .join(" · ");
  }
  if (typeof detail === "string") return detail;
  if (typeof err?.message === "string") return err.message;
  return fallback;
}
